import React from "react";
import _ from "lodash";
import {generateQueryParamsHash, useSharedDataContext} from "../utils";
import {useTabsSharedDataContext} from "../components_v2/TabsSharedData/TabsSharedData";
import {isCancel, useCancelableRequest} from "../../../hooks/useCancelableRequest";

const SHARED_DATA_KEY = 'basic-assets-data';

export function useBasicPortfolioData(customerId, portfolio, dataProvider) {

  const dataContext = useSharedDataContext();
  const sharedData = useTabsSharedDataContext();
  const getCancelToken = useCancelableRequest();
  const dataKey = `${SHARED_DATA_KEY}-${portfolio.depotNumber}`;
  const portfolioData = dataContext.getPortfolioData(portfolio.depotNumber);

  const fetchBasicPortfolioData = () => {
    if(dataContext.isPortfolioDataLoading(portfolio.depotNumber)){
      return;
    }

    const cancelToken = getCancelToken();

    const _setState = (depotNr, depotData, onlyCache=false) => {
      // It is not possible to sync data with shared data in
      // hook because hook is not executed if component destroyed
      if(!onlyCache) {
        dataContext.setPortfolioData(depotNr, depotData);
      }
      sharedData.setDataValue(dataKey, hashKey, depotData);
    };

    const hashKey = generateQueryParamsHash(customerId, [portfolio]);

    dataContext.setPortfolioDataLoading(portfolio.depotNumber, true);
    _setState(portfolio.depotNumber,{
      basicPortfolioData: null,
      basicPortfolioLoading: true,
      basicPortfolioError: null,
      updatedAt: +new Date(),
    });

    dataProvider.getBasicPortfolioData(customerId, portfolio.depotNumberForAssets || portfolio.depotNumber, undefined, undefined, undefined, undefined, cancelToken)
      .then((response) => {
        response.portfolio_data.data[0].components = _.orderBy(response.portfolio_data.data[0].components, ['weight'], 'desc')
        if(!!portfolio){
          // portfolio name is changed to display name instead of id
          response.portfolio_data.data[0].name = portfolio.name;
        }
        _setState(portfolio.depotNumber, {
          basicPortfolioData: response,
          basicPortfolioLoading: false,
          basicPortfolioError: null,
          updatedAt: +new Date()
        })
      })
      .catch((error) => {
        _setState(portfolio.depotNumber, {
          basicPortfolioData: null,
          basicPortfolioLoading: false,
          basicPortfolioError: error,
          updatedAt: +new Date()
        }, isCancel(error))
      })
      .finally(() => {
        dataContext.setPortfolioDataLoading(portfolio.depotNumber, false);
      })
  };

  const syncFromShared = () => {
    const sharedPortfolioData = !!sharedData
      ? sharedData.getDataValue(dataKey, generateQueryParamsHash(customerId, [portfolio]))
      : undefined;

    if (!!sharedPortfolioData && !sharedPortfolioData.basicPortfolioError && sharedPortfolioData.updatedAt !== portfolioData.updatedAt) {
      // sync internal hook data with shared data.
      dataContext.setPortfolioData(portfolio.depotNumber, sharedPortfolioData);

      return true
    } else {
      return false;
    }
  };

  React.useEffect(() => {syncFromShared()}, [_.get(sharedData, 'updatedAt')]);

  React.useEffect(() => {
    if (!!customerId && !!portfolio) {
      const synced = syncFromShared();

      if (!synced) {
        fetchBasicPortfolioData();
      }
    }
  }, [customerId, _.get(portfolio, 'depotNumberForAssets'), _.get(portfolio, 'depotNumber')]);

  return {
    basicPortfolioData: portfolioData
  }

}